import React from "react";


interface Props {
  id?: string;
  className?: string;
  title: string;
  placeholder: string;
  value: string;
  type: "text" | "password" | "number" | "email" | "tel";
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onCompositionStart?: (e: React.CompositionEvent<HTMLInputElement>) => void;
  onCompositionEnd?: (e: React.CompositionEvent<HTMLInputElement>) => void;
  errorMessage: string;
  suffix?: React.JSX.Element | Array<React.JSX.Element>;
  suffixClassName?: string;
  labelEnable?: boolean;
  isDisabled?: boolean;
  inputMode?: "text" | "numeric" | "decimal" | "tel" | "search" | "email" | "none";
  maxLength?: number;
  isReadOnly?: boolean;
  autoComplete?: string;
}

export const BaseTextFieldBox = (props: Props) => {
  const {
    id,
    className="",
    value,
    onChange,
    onFocus,
    onBlur,
    onCompositionStart,
    onCompositionEnd,
    type,
    errorMessage,
    title,
    placeholder,
    suffix,
    suffixClassName = "",
    labelEnable = false,
    isDisabled = false,
    inputMode = "text",
    maxLength,
    isReadOnly = false,
    autoComplete = "off",
  } = props;

  return (
    <>
      {labelEnable && <label htmlFor={id} className="lbl-title">{title}</label>}
      {isDisabled ? (
        <div
          id={id}
          className={className}
        >
          {value.length === 0 ? placeholder : value}
        </div>
      ) : (
        <input
          id={id}
          className={className}
          type={type}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onCompositionStart={onCompositionStart}
          onCompositionEnd={onCompositionEnd}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required
          autoCapitalize="off"
          inputMode={inputMode}
          {...(maxLength ? { maxLength } : {})}
          readOnly={isReadOnly}
        />
      )}
      {suffix && (
        <div className={suffixClassName}>
          {suffix}
        </div>
      )}

      {errorMessage && (
        <p className="text-box-error-message">{errorMessage}</p>
      )}
    </>
  );
};
